import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

const MENU_NOT_DELETABLE_ERROR_NAME = 'MenuNotDeletableError';

export const isMenuNotDeletableError = (err: unknown): err is Error =>
  err instanceof Error && err.name === MENU_NOT_DELETABLE_ERROR_NAME;

export const deleteMenu = async (menuId: string, dryRun?: boolean): Promise<void> => {
  const query = dryRun ? '?dryRun=true' : '';
  const res = await fetch(`${API_URL}/menus/${menuId}${query}`, {
    method: 'DELETE',
  });

  if (res.status === Status.BAD_REQUEST || res.status === Status.NOT_FOUND) {
    const message = await res
      .json()
      .then((json) => json.message)
      .catch(() => 'Could not delete menu');
    const error = new Error(message);
    error.name = MENU_NOT_DELETABLE_ERROR_NAME;
    throw error;
  }

  if (!res.ok) {
    throw new Error('Could not delete menu');
  }
};

export const canDeleteMenu = (menuId: string): Promise<void> => deleteMenu(menuId, true);
